import { ModuleConfig } from '@core/interfaces';

const config: ModuleConfig = {
  name: 'Busk',
  baseUrl: '',
  routes: [
    {
      path: '/admin/busk/',
      page: 'BuskAdminDashboard',
      title: 'Busk Admin busk',
      exact: true
    }
  ],
  requireAuthenticated: true
};

export default config;
